import format from 'date-fns/format';
import React from 'react';
import AsyncSelect from 'react-select/async';

import { userSelectStyles } from '../select-styles';

const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

const timesGenerator = (hr, suffix = 'AM') => [
  { value: `${hr}:00 ${suffix}`, label: `${hr}:00 ${suffix}` },
  { value: `${hr}:15 ${suffix}`, label: `${hr}:15 ${suffix}` },
  { value: `${hr}:30 ${suffix}`, label: `${hr}:30 ${suffix}` },
  { value: `${hr}:45 ${suffix}`, label: `${hr}:45 ${suffix}` },
];

const ams = hours.map((hr) => timesGenerator(hr, 'AM')).flat();
const pms = hours.map((hr) => timesGenerator(hr, 'PM')).flat();

const timeOptions = [...ams, ...pms];

const UNSET_TIME = ['11:59 PM', '12:01 AM'];

export const TimePicker = ({
  inputDate,
  setInputDate,
  onTimeChange,
}: {
  inputDate: Date;
  setInputDate: React.Dispatch<React.SetStateAction<Date | null | undefined>>;
  onTimeChange: (Date) => void;
}) => {
  const onSelectTime = (val) => {
    const updatedTime = new Date(`${inputDate.toDateString()} ${val.value}`);
    setInputDate(updatedTime);
    if (onTimeChange) onTimeChange(updatedTime);
  };

  const filterTimes = (inputValue: string) => {
    // more fuzzy search filters here
    return timeOptions.filter(
      (time) => time.label.toUpperCase().indexOf(inputValue.toUpperCase()) > -1
    );
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: { value: string; label: string }[]) => void
  ) => {
    callback(filterTimes(inputValue));
  };

  return (
    <>
      <AsyncSelect
        className="w-100 text-sm bg-gray-100 outline-none"
        classNamePrefix="select"
        isSearchable
        name="color"
        placeholder="Add time"
        value={
          UNSET_TIME.includes(format(inputDate, 'p'))
            ? null
            : {
                value: inputDate.toTimeString(),
                label: format(inputDate, 'p'),
              }
        }
        styles={{
          ...userSelectStyles,
          control: (styles) => ({
            ...styles,
            outline: 'none',
            border: 'none',
            backgroundColor: '#f6f7f9',
            borderColor: 'transparent',
            boxShadow: '0 0 0 1px #2684ff00',
            ':hover': {
              borderColor: 'transparent',
            },
          }),
          valueContainer: (styles) => ({
            ...styles,
            padding: '0',
          }),
          menu: (styles) => ({
            ...styles,
            width: '140px',
            transform: 'translateX(-30px)',
          }),
        }}
        onChange={onSelectTime}
        loadOptions={loadOptions}
        defaultOptions
        components={{
          DropdownIndicator: null,
        }}
      />
    </>
  );
};
